const FETCH_SEANCE_REPORTS = 'fetch_seanceReports';
const FETCH_SEANCE_REPORTS_CSV = 'fetch_seanceReports_csv';
const FETCH_SEANCE_REPORTS_TOTAL = 'fetch_seanceReports_total';
const FETCH_SEANCE_REPORT = 'fetch_seanceReport';
const DELETE_SEANCE_REPORT = 'delete_seanceReport';
const PERSIST_SEANCE_REPORT = 'persist_seanceReport';
export default {
    FETCH_SEANCE_REPORTS,
    FETCH_SEANCE_REPORTS_CSV,
    FETCH_SEANCE_REPORTS_TOTAL,
    FETCH_SEANCE_REPORT,
    DELETE_SEANCE_REPORT,
    PERSIST_SEANCE_REPORT,
};
